import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import { themeCreator } from "./base";
import { createRtlCache } from "../utils/rtlCache";
import { RootState } from "../reduxServer/store";

const ThemeProviderWrapper = ({ children }) => {
  const mode = useSelector((state: RootState) => state.theme.mode);
  const lang = useSelector((state: RootState) => state.language.lang) || "ar";
  const isRTL = lang === "ar";

  const baseTheme = themeCreator(
    mode === "light" ? "PureLightTheme" : "PureDarkTheme"
  );

  const theme = useMemo(
    () =>
      createTheme({
        ...baseTheme,
        direction: isRTL ? "rtl" : "ltr",
      }),
    [baseTheme, isRTL]
  );

  const cache = useMemo(() => createRtlCache(isRTL), [isRTL]);

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
  }, [isRTL]);

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};

export default ThemeProviderWrapper;


